<template>
  <div @click="download" class="elevation-0">
    <slot v-bind="{ loading }"></slot>
    <a @click.stop="" v-show="false" :href="href" ref="anchor" :download="computedName" target="_blank" />
  </div>
</template>

<script>
import axios from 'axios'
import { useUtil } from '@/plugins/util'
import { createNamespacedHelpers } from 'vuex'

const { mapState: authState } = createNamespacedHelpers('auth')

export default {
  props: {
    url: {
      type: Blob,
      required: true,
    },
    name: {
      type: String,
    },
    /**
     * Indica se o link (url) se refere a um link 'estático' do backend,
     * sendo necessário criar um Blob para fazer valer a propriedade
     * name no momento do download
     */
    remoteUrl: Boolean,
    disabled: Boolean,
    onBeforeDownload: Function,
    alwaysForceDownload: Boolean,
  },
  computed: {
    ...authState(['token']),
    computedName() {
      return this.name || this.responseFilename || 'download'
    },
  },
  data() {
    return {
      loading: false,
      href: null,
      responseFilename: null,
    }
  },
  methods: {
    async getHref() {
      if (this.href && !this.alwaysForceDownload) {
        return this.href
      }

      if (!this.remoteUrl) {
        return this.url
      }

      try {
        this.loading = true
        let authorizationHeader = this.remoteUrl ? { Authorization: `Bearer ${this.token}` } : {}

        const response = await axios({
          url: this.url,
          method: 'get',
          responseType: 'blob',
          headers: { 'Access-Control-Expose-Headers': 'Content-Disposition', ...authorizationHeader },
        })

        this.responseFilename =
          response.headers['Content-Disposition']?.split('filename=')[1] ||
          response.headers['content-disposition']?.split('filename=')[1]

        return window.URL.createObjectURL(response.data)
      } catch (error) {
        const errorText = await error?.response?.data?.text()
        const errorObject = JSON.parse(errorText | {})
        this.$root.error(errorObject?.error || 'Não foi possível fazer o download')
      } finally {
        this.loading = false
      }

      return null
    },

    async download() {
      if (this.disabled) {
        return
      }
      if (this.onBeforeDownload) {
        await this.onBeforeDownload()
      }
      this.$nextTick(() => {
        this.util.downloadBlob(this.url, this.computedName)
      })
    },
  },
  setup() {
    const util = useUtil()

    return {
      util,
    }
  },
}
</script>

<style></style>
